import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AlertController, ModalController, PopoverController } from '@ionic/angular';

export interface CanLeavePage {
  canLeave: () => true;
}

export const modalGuard: CanDeactivateFn<CanLeavePage> = async (_route, _state, nextState) => {
  const modalService = inject(ModalController);
  const alertService = inject(AlertController);
  const popoverService = inject(PopoverController);

  let shouldBreak = false;

  while (!shouldBreak) {
    try {
      const popoverIstance = await popoverService.getTop();
      if (popoverIstance) {
        await popoverIstance.dismiss();
      } else {
        shouldBreak = true;
      }
    } catch (error) {
      shouldBreak = true;
    }
  }

  if (!nextState.url.includes('wallet')) {
    const alertInstance = await alertService.getTop();

    if (alertInstance) {
      await alertInstance.dismiss();
      return false;
    }

    const modalIstance = await modalService.getTop();
    if (modalIstance) {
      await modalIstance.dismiss();
      return false;
    }
  }

  return true;
};
